<template>
  <div>
    <div class="download_bg">
      <img src="../../assets/img/download_img_new.png" alt="" />
    </div>
    <div class="download_bottom">
      <div class="left">
        <img src="../../assets/img/download_qrcode.png" alt="" />
      </div>
      <div class="right">
        <div class="btn" @click="doDownLoad">下载新版</div>
        <p class="txt">查看更多内容请下载APP</p>
      </div>
    </div>
    <template v-if="isShow">
      <div class="down_guide">
        <div class="guide_img">
          <img src="../../assets/img/down_guide2.png" />
        </div>
        <div class="close_btn" @click="doHide">关闭</div>
      </div>
      <div class="tk_bg"></div>
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isShow: false,
      isWeixin: false,
    };
  },
  created() {
    document.title = "APP下载";
    this.is_weixn();
  },
  methods: {
    doDownLoad() {
      var ua = navigator.userAgent;
      var isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      //如果是苹果系统
      if (isiOS) {
        window.location.href = "https://itunes.apple.com/us/app/id1560762275?mt=8";
      } else {
        //如果是安卓系统
        if (this.isWeixin) {
          //如果是微信浏览器那么弹出引导页
          this.isShow = true;
        } else {
          //否则展示下载按钮
          this.isShow = false;
          window.location.href = "http://d.hkrt.cn/hksht.apk";
        }
      }
    },
    // 判断是不是微信浏览器
    is_weixn() {
      var ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        this.isWeixin = true;
      } else {
        this.isWeixin = false;
      }
    },
    //隐藏引导页
    doHide() {
      this.isShow = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.download_bg {
  width: 100%;
}
.download_bg img {
  width: 100%;
  height: 100%;
}
.download_bottom {
  padding: 25px;
  display: flex;
  align-items: center;
  align-content: center;
}
.download_bottom .left {
  width: 115px;
  flex-shrink: 0;
}
.download_bottom .left img {
  display: block;
  width: 100%;
}
.download_bottom .right {
  flex-shrink: 1;
  width: 100%;
  margin-left: 25px;
}
.download_bottom .btn {
  width: 100%;
  height: 46px;
  font-size: 17px;
  color: #fff;
  line-height: 46px;
  text-align: center;
  background: #1738ff;
  border-radius: 23px;
}
.download_bottom .txt {
  margin-top: 20px;
  font-size: 12px;
  color: #0721bd;
  text-align: center;
}
.tk_bg {
  width: 100%;
  height: 100%;
  background: #000;
  opacity: 0.7;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
}
.down_guide {
  width: 100%;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 3;
}
.guide_img {
  width: 100%;
  margin-top: 12px;
  text-align: right;
  padding-right: 20px;
  box-sizing: border-box;
}
.guide_img img {
  width: 306px;
}
.close_btn {
  border: 2px solid #fff;
  width: 275px;
  height: 50px;
  border-radius: 25px;
  text-align: center;
  color: #fff;
  font-size: 20px;
  line-height: 50px;
  margin: 202px auto 0;
}
</style>
